import detectIncognito from "detectincognitojs";
import { useEffect, useState } from "react"

/** Ověří, zda uživatel náhodou není v incognito režimu */
export const useIncognitoProtection = () => {

    /** Je uživatel v incognito režimu? */
    const [
        isIncognito,
        setIsIncognito
    ] = useState<boolean>(false);

    const [
        mayConnect,
        setMayConnect
    ] = useState<boolean>(false);

    // Nejprve detekujeme incognito režim
    useEffect(() => {

        detectIncognito().then(result => {

            setIsIncognito(result.isPrivate);

            if (!result.isPrivate) {
                setMayConnect(true);
            }

        });

    }, []);

    return {
        isIncognito,
        mayConnect
    }

}
